'use client';

import { useCallback } from 'react';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import useSafePush from 'src/hooks/useSafePush';
import { isWindowDefined } from 'src/utils/browser';

const useGoToRoute = () => {
	const authorityParam = useVelocityStore((s) => s.authorityParam);
	const safePush = useSafePush();

	const goToRoute = useCallback(
		(href: string) => {
			if (href.includes('https')) {
				if (isWindowDefined()) {
					window.open(href, '_blank', 'noopener,noreferrer');
				}
				return;
			}

			let delimiter;
			if (authorityParam?.length == 0) {
				delimiter = '';
			} else if (href.includes('?')) {
				delimiter = '&';
			} else {
				delimiter = '?';
			}

			safePush(`${href}${delimiter}${authorityParam ?? ''}`);
		},
		[safePush, authorityParam]
	);

	return goToRoute;
};

export default useGoToRoute;
